<template>
  <div id="app">
      <div id="menu" :class="{ mobile : isMobile }">
        <img id="glow" src="./assets/tgglow.png"/>
        <img v-on:click="switchPage();" src="./assets/tg2.png"/>
      </div>
   <div class="router">
    </div>
    <router-view :isMobile="isMobile" :compilationTracks='compilationTracks' :userGesture='userGesture' @userGesture="userGesture = true"></router-view>
        <div id="bandcamp" :class="{ mobile : isMobile }"><a target="_blank" href="https://traumgarten.bandcamp.com/album/flowers-that-bloom-at-midnight">purchase on<span><img src="./assets/bandcamp-logotype-light-128.png"/></span></a></div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      compilationTracks: null,
      menu: false,
      userGesture: false,
      isMobile: null
    }
  },
  created() {
    var selfobject = this;
    axios.get('https://traumgarten.dev0ted.tech/compilation-tracks')
      .then(function (response) {
        selfobject.compilationTracks = response["data"];
      })
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (window.innerWidth <= 800 || isMobile) {
      this.isMobile = true;
    }
  },
  methods: {
    switchPage() {
      if (this.$route.path == '/compilation' || this.$route.path == '/') {
        this.$router.push({ path: 'about' })
      } else {
        this.$router.push({ path: 'compilation' })
      }
      }
    }
}
</script>

<style>
@font-face {
  font-family: tg;
  src: url(../src/assets/SM.otf);
}

@font-face {
  font-family: ital;
  src: url(../src/assets/SMI.otf);
}

@font-face {
  font-family: np;
  src: url(../src/assets/NationalPark-Regular.otf);
}

@font-face {
  font-family: flowers;
  src: url(../src/assets/BreakItSweet.ttf);
}


html, body {
  margin: 0;
  padding: 0;
  width:100%;
  height:100%;
  box-sizing: border-box;
  overflow: hidden;
}

*, *::before, *::after {
  box-sizing: border-box;
}

a:link {
  cursor:pointer;
  text-decoration:none;
  /* color:black; */
}

#app {
  background-color:black;
  position:absolute;
  font-family: "tg";
  top:0;left:0;
  width:100%;
  height:100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    overflow: auto;
}

#menu {
  position:absolute;
  /* padding-left:-50px; */
  cursor:pointer;
  width:13vw;
  /* margin-left:-40px; */
  top:5%;
  left:5vw;
  line-height:1;
  z-index:501;
}

#menu.mobile {
  width:35%;
  position:fixed;
}

#menu img {
  width:100%;
  height:auto;
  position:absolute;
}

img#glow {
  animation: glow 8s infinite;
}

@keyframes glow {
  0% {opacity: 0;}
  50% {opacity: 1;}
  100% {opacity: 0;}
}

#bandcamp {
  color:white;
  font-size:20px;
  bottom:30px;
  right:12px;
  font-family: np;
  position:fixed;
  width:300px;
  height:25px;
  z-index:501;
  text-align:right;
}

#bandcamp.mobile {
  font-size:6vw;
  width:90vw;
}


#bandcamp a {
  color: white;
}


#bandcamp img {
  position:relative;
  top:14px;
  height:38px;
  width:auto;
}
</style>
